'use client';

import { ArrowLeft, Home } from 'lucide-react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { MessageDisplay, MessageDisplayButton } from '@/components/message-display';

const NotFoundPage: React.FC = () => {
  const router = useRouter();
  const t = useTranslations('app.notFound');

  const handleGoBack = () => {
    router.back();
  };

  return (
    <MessageDisplay
      intent="error"
      title={t('title')}
      description={t('description')}
      size="page"
      errorCode={404}
      className="h-screen"
    >
      <MessageDisplayButton onClick={handleGoBack}>
        <ArrowLeft className="size-4" />
        {t('back')}
      </MessageDisplayButton>
      <MessageDisplayButton variant="default" asChild>
        <Link href="/">
          <Home className="size-4" />
          {t('home')}
        </Link>
      </MessageDisplayButton>
    </MessageDisplay>
  );
};

export default NotFoundPage;
